var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53518 15.5352C2.45411 14.6162 3.70044 14.1 5.00001 14.1H13C14.2996 14.1 15.5459 14.6162 16.4648 15.5352C17.3838 16.4541 17.9 17.7004 17.9 19V21C17.9 21.497 17.4971 21.9 17 21.9C16.5029 21.9 16.1 21.497 16.1 21V19C16.1 18.1778 15.7734 17.3893 15.192 16.8079C14.6107 16.2266 13.8222 15.9 13 15.9H5.00001C4.17784 15.9 3.38934 16.2266 2.80798 16.8079C2.22661 17.3893 1.90001 18.1778 1.90001 19V21C1.90001 21.497 1.49706 21.9 1.00001 21.9C0.50295 21.9 0.100006 21.497 0.100006 21V19C0.100006 17.7004 0.616255 16.4541 1.53518 15.5352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1 15C18.1 14.5029 18.5029 14.1 19 14.1C20.2995 14.1 21.5459 14.6162 22.4648 15.5351C23.3837 16.4541 23.9 17.7004 23.9 19V21C23.9 21.497 23.497 21.9 23 21.9C22.5029 21.9 22.1 21.497 22.1 21V19C22.1 18.1778 21.7734 17.3893 21.192 16.8079C20.6106 16.2266 19.8222 15.9 19 15.9C18.5029 15.9 18.1 15.497 18.1 15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 3.89998C7.28792 3.89998 5.90001 5.28789 5.90001 6.99998C5.90001 8.71206 7.28792 10.1 9.00001 10.1C10.7121 10.1 12.1 8.71206 12.1 6.99998C12.1 5.28789 10.7121 3.89998 9.00001 3.89998ZM4.10001 6.99998C4.10001 4.29378 6.29381 2.09998 9.00001 2.09998C11.7062 2.09998 13.9 4.29378 13.9 6.99998C13.9 9.70617 11.7062 11.9 9.00001 11.9C6.29381 11.9 4.10001 9.70617 4.10001 6.99998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1281 2.90674C15.2514 2.42522 15.7417 2.13481 16.2232 2.2581C17.2773 2.52797 18.2115 3.14096 18.8786 4.00043C19.5457 4.8599 19.9078 5.91697 19.9078 7.00498C19.9078 8.09299 19.5457 9.15005 18.8786 10.0095C18.2115 10.869 17.2773 11.482 16.2232 11.7519C15.7417 11.8751 15.2514 11.5847 15.1281 11.1032C15.0048 10.6217 15.2952 10.1314 15.7768 10.0081C16.4436 9.83737 17.0346 9.44956 17.4567 8.90581C17.8788 8.36206 18.1078 7.69331 18.1078 7.00498C18.1078 6.31664 17.8788 5.64789 17.4567 5.10414C17.0346 4.56039 16.4436 4.17258 15.7768 4.00185C15.2952 3.87856 15.0048 3.38826 15.1281 2.90674Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.c64b74fd7eca86e0eda43e9292e27ae7.svg";
export { ForwardRef as ReactComponent };